<template>
    <v-overlay :value="overlay">
        <div class="d-flex flex-column" style="text-align:center">
            <v-progress-circular indeterminate size="64" style="align-self: center;"></v-progress-circular>
            <br><div v-html="getMessage" />
        </div>
    </v-overlay>
</template>

<script>
export default {
    props: ["messageSelector", "overlay"],
    data(){
        return {
        }
    },
    created(){

    },
    computed: {
        getMessage(){
            let result = "";

            if(this.messageSelector){
                switch(this.messageSelector){
                    case "Save":
                        result = "Sauvegarde des modifications en cours"
                        break;
                    case "Facture":
                        result = "Génération de votre facture en cours<br>Cette opération peut prendre jusqu'à deux minutes";
                        break;
                    case "Creation":
                        result = "Création de votre dossier en cours.<br>Cette opération peut prendre jusqu'à deux minutes"
                        break;
                    case "Loading":
                        result = "Chargement des données en cours";
                        break;
                }   
            }

            return result;
        }
    },
    methods: {

    }
}
</script>

<style>

</style>